export default __webpack_public_path__ + "static/media/thai-food.da899e97.jpeg";